import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWindowClose } from '@fortawesome/free-solid-svg-icons';

const UnitOfficeSection = ({ 
    updatedClient, 
    data, 
    updateUnit, 
    removeUnit, 
    addUnit 
}) => {
    return (
        <div className='mb-2'>
            <h5 className='mt-4'>
                {data.t.read("client_table.unit_office_list")}
                <button className='btn btn-info btn-xs ml-2' type="button"
                    onClick={addUnit}>+
                </button>
            </h5>
            {
                updatedClient.supplier_units && updatedClient.supplier_units.map((unit, i) => {
                    return <div key={i}>
                        <div className='row mb-1'>
                            <div className='col-3'>
                                <input required
                                    placeholder={data.t.read("client_table.units_offices")}
                                    className='form-control' type="text"
                                    value={unit.unit}
                                    onChange={(e) => updateUnit(i, "unit", e.target.value)} />
                            </div>
                            <div className='col-7'>
                                <input required placeholder={"Description"}
                                    className='form-control' type="text"
                                    value={unit.desc}
                                    onChange={(e) => updateUnit(i, "desc", e.target.value)} />
                            </div>
                            <div className='col-2 text-right pt-1'>
                                <button type="button" className="btn btn-link"
                                    onClick={() => removeUnit(i)}>
                                    <FontAwesomeIcon className="text-danger"
                                        icon={faWindowClose} />
                                </button>
                            </div>
                        </div>
                    </div>
                })
            }
        </div>
    );
};

export default UnitOfficeSection;
